import React from "react";
import Login from "../Components/Login/Login";

const LoginPage: React.FC = () => <Login />;

export default LoginPage;
